$(document).ready(function () {
  const freelancersGridId = "freelancers-grid";
  initYiiGrid(freelancersGridId, {
    ajaxUpdate: [freelancersGridId],
    ajaxVar: "ajax",
    ajaxType: "POST",
    enableHistory: false,
    filterClass: "filters",
    filterSelector: "{filter}",
    loadingClass: "grid-view-loading",
    pageVar: "ProjectsTasks_page",
    pagerClass: "pager",
    selectableRows: 1,
    tableClass: "table table-bordered sr-freelancers-list",
    updateSelector: "{page}, {sort}",
    csrfTokenName: csrfTokenName,
    csrfToken: token,
  });

  function updateDatepicker () {
    $(".datepicker").each(function () {
      var elem = $(this);
      elem.datepicker({
        format: "dd.mm.yyyy",
        autoclose: true,
        language: "ru",
      });
    });
  }

  $(document).on("afterAjaxUpdate.yiiGridView", `#${freelancersGridId}`, updateDatepicker);

  $(".exclude-freelancer").click(function (event) {
    event.preventDefault();

    var that = $(this);

    $.SmartMessageBox(
      {
        title: translate.customer_stop_work_caption,
        content: translate.customer_stop_work_message,
        buttons: "[" + translate.button_no + "][" + translate.button_yes + "]",
      },
      function (ButtonPressed) {
        if (ButtonPressed === translate.button_yes) {
          location.href = that.attr("href");
        }
      }
    );
  });
  const rmAddClassExp = (cl, rm, add) => $(cl).removeClass(rm).addClass(add);

  if (Cookies.get("freelancer-info-closed")) {
    toggleFreelPanel();
  }

  $(".toggle-freelancer").on("click", function () {
    if (Cookies.get("freelancer-info-closed")) {
      Cookies.remove("freelancer-info-closed");
    } else {
      Cookies.set("freelancer-info-closed", 1);
    }
    toggleFreelPanel();
  });

  function toggleFreelPanel() {
    $("#freelancer_instructions").toggleClass("closed");

    if ($("#freelancer_instructions").hasClass("closed")) {
      rmAddClassExp(
        "#freelancer_instructions .fa-chevron-up",
        "fa-chevron-up",
        "fa-chevron-down"
      );
      return;
    }

    rmAddClassExp(
      "#freelancer_instructions .fa-chevron-down",
      "fa-chevron-down",
      "fa-chevron-up"
    );
  }

  $("#inviteModal").on("shown.bs.modal", function () {
    $("#invite_email").focus();
  });

  $("#phoneRequestModal").on("shown.bs.modal", function () {
    $("#phone-request").focus();
    $("#phone-request").inputmask({
      mask: "+9999 99[9] [9999] [9][9][9][9][9][9]",
      greedy: false,
    });
  });

  $("#export-freel-xls").on("click", function (e) {
    e.preventDefault();

    let inputs = $(".filters input, .filters select");
    let form = $("#exportFreelancers");
    form.find(".export-freelancer-filter").remove();

    $.each(inputs, function (index, value) {
      let el = $(value)
        .clone()
        .css("display", "none")
        .addClass("export-freelancer-filter");
      form.append(el);
    });

    form.submit();
  });

  $("#export-halva-xls").on("click", function (e) {
    e.preventDefault();

    let inputs = $(".filters input, .filters select");
    let form = $("#exportFreelancers");
    form.find(".export-freelancer-filter").remove();

    $.each(inputs, function (index, value) {
      let el = $(value)
        .clone()
        .css("display", "none")
        .addClass("export-freelancer-filter");
      form.append(el);
    });

    form.append(
      `<input type="hidden" class="export-freelancer-filter" name="isHalvaCardHoldersNeeded" value="true">`
    );
    form.submit();
  });

  $(".customer-note-for-freelancer").editable({
    params: function (params) {
      params["YII_CSRF_TOKEN"] = token;
      return params;
    },
    success: function(response, newValue) {
      response = JSON.parse(response);
      if(response.code !== 0) {
        return response.response;
      }
      return;
    },
  });

  new ClipboardJS(".copy-to-clipboard", {
    target: function (trigger) {
      return $(`#${$(trigger).attr("data-clipboard-target")}`)[0];
    },
  });
});
